const EditorSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path
        d="M2.91797 2.91699H2.5013C2.28029 2.91699 2.06833 3.00479 1.91205 3.16107C1.75577 3.31735 1.66797 3.52931 1.66797 3.75033V7.50033C1.66797 7.72134 1.75577 7.9333 1.91205 8.08958C2.06833 8.24586 2.28029 8.33366 2.5013 8.33366H6.2513C6.47232 8.33366 6.68428 8.24586 6.84056 8.08958C6.99684 7.9333 7.08464 7.72134 7.08464 7.50033V7.08366"
        stroke="#D5D5D5"
        stroke-width="0.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 2.08338L7.91667 3.33338M8.49375 2.74379C8.65785 2.57969 8.75004 2.35712 8.75004 2.12504C8.75004 1.89297 8.65785 1.6704 8.49375 1.50629C8.32965 1.34219 8.10708 1.25 7.875 1.25C7.64292 1.25 7.42035 1.34219 7.25625 1.50629L3.75 5.00004V6.25004H5L8.49375 2.74379Z"
        stroke="#D5D5D5"
        strokeWidth="0.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditorSvg;
